import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import { AuthProvider } from './contexts/AuthContext';
import { VapiProvider } from './contexts/VapiContext';
import { AzureAIChatProvider } from './contexts/AzureAIChatContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { VapiWidget } from './components/vapi/VapiWidget';
import { AzureAIChatWidget } from './components/azure-chat/AzureAIChatWidget';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductsOldPage from './pages/ProductsOldPage';
import ProductDetailPage from './pages/ProductDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VoiceExperiencePage from './pages/VoiceExperiencePage';
import DemoRequestPage from './pages/DemoRequestPage';
import ContactPage from './pages/ContactPage';
import WismoPage from './pages/use-cases/WismoPage';
import PasswordResetPage from './pages/use-cases/PasswordResetPage';
import BillingPaymentsPage from './pages/use-cases/BillingPaymentsPage';
import EmployeeOnboardingPage from './pages/use-cases/EmployeeOnboardingPage';
import IdentityVerificationPage from './pages/use-cases/IdentityVerificationPage';
import SoftwareProvisioningPage from './pages/use-cases/SoftwareProvisioningPage';
import CaseTriagePage from './pages/use-cases/CaseTriagePage';
import GroupsManagementPage from './pages/use-cases/GroupsManagementPage';
import AppointmentSchedulingPage from './pages/use-cases/AppointmentSchedulingPage';
import HardwareSupportPage from './pages/use-cases/HardwareSupportPage';
import ProductsPreviewPage from './pages/ProductsPreviewPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import DPAPage from './pages/DPAPage';
import AccessibilityPage from './pages/AccessibilityPage';
import AIVoiceAgentPage from './pages/AIVoiceAgentPage';
import AnalyticsChatAgentsPage from './pages/AnalyticsChatAgentsPage';
import AICustomerCarePage from './pages/AICustomerCarePage';
import AIWebChatPage from './pages/AIWebChatPage';
import AIWorkflowAutomationPage from './pages/AIWorkflowAutomationPage';
import AIComplianceStudioPage from './pages/AIComplianceStudioPage';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import DocsPage from './pages/DocsPage';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <VapiProvider>
        <AzureAIChatProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="App min-h-screen flex flex-col">
              <Navigation />
              <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/use-cases/order-status" element={<WismoPage />} />
                <Route path="/use-cases/password-reset" element={<PasswordResetPage />} />
                <Route path="/use-cases/billing-payments" element={<BillingPaymentsPage />} />
                <Route path="/use-cases/employee-onboarding" element={<EmployeeOnboardingPage />} />
                <Route path="/use-cases/identity-verification" element={<IdentityVerificationPage />} />
                <Route path="/use-cases/software-provisioning" element={<SoftwareProvisioningPage />} />
                <Route path="/use-cases/case-triage" element={<CaseTriagePage />} />
                <Route path="/use-cases/groups-management" element={<GroupsManagementPage />} />
                <Route path="/use-cases/appointment-scheduling" element={<AppointmentSchedulingPage />} />
                <Route path="/use-cases/hardware-support" element={<HardwareSupportPage />} />
                <Route path="/products" element={<ProductsPreviewPage />} />
                <Route path="/products-old" element={<ProductsOldPage />} />
                <Route path="/products/:productId" element={<ProductDetailPage />} />
                <Route path="/pricing" element={<Navigate to="/contact" replace />} />
                <Route path="/demo" element={<DemoRequestPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/cookie-policy" element={<CookiePolicyPage />} />
                <Route path="/dpa" element={<DPAPage />} />
                <Route path="/accessibility" element={<AccessibilityPage />} />
                <Route path="/ai-voice-agent" element={<AIVoiceAgentPage />} />
                <Route path="/analytics-chat-agents" element={<AnalyticsChatAgentsPage />} />
                <Route path="/ai-customer-care" element={<AICustomerCarePage />} />
                <Route path="/ai-web-chat" element={<AIWebChatPage />} />
                <Route path="/ai-workflow-automation" element={<AIWorkflowAutomationPage />} />
                <Route path="/ai-compliance-studio" element={<AIComplianceStudioPage />} />
                <Route path="/voice-experience" element={<VoiceExperiencePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogDetailPage />} />
                <Route path="/case-studies" element={<CaseStudiesPage />} />
                <Route path="/docs" element={<DocsPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
            {/* <VapiWidget /> */}
            <AzureAIChatWidget />
          </div>
        </BrowserRouter>
        </AzureAIChatProvider>
      </VapiProvider>
    </AuthProvider>
  );
}

export default App;